/**
 * Agrupación comercial de permisos operativos (Equipo / Roles).
 * No es un Authorization Engine nuevo: solo presenta el catálogo existente.
 */
import type { OperationalPermission } from "./operational-permissions";

export type PermissionGrantSource = "role" | "direct_allow" | "direct_deny" | "owner" | "none";

/**
 * Semántica de grant efectivo (CODE IS LAW — assertSmStaffPermission):
 *
 * - OWNER / super_admin / viewer: bypass (no aplican plantillas staff).
 * - INHERIT (sin override): permiso presente en plantilla del rol → ALLOW; ausente → NOT_GRANTED.
 * - DIRECT ALLOW (override true): ALLOW aunque el rol no lo tenga.
 * - DIRECT DENY (override false): DENY aunque el rol lo tenga.
 * - NOT_GRANTED: staff sin rol, rol sin plantilla, o permiso ausente sin override allow.
 *
 * No existe un estado "INHERIT" persistido: la ausencia de clave en
 * permission_overrides es INHERIT implícito.
 */
export type PermissionGrantSemantics =
  | "ALLOW"
  | "DENY"
  | "INHERIT"
  | "NOT_GRANTED";

export interface OperationalPermissionDomain {
  id: string;
  label: string;
  description: string;
  permissions: OperationalPermission[];
}

export const OPERATIONAL_PERMISSION_DOMAINS: OperationalPermissionDomain[] = [
  {
    id: "catalogo",
    label: "Catálogo",
    description: "Productos, precios y stock",
    permissions: ["can_manage_catalog", "can_override_stock"],
  },
  {
    id: "pedidos",
    label: "Pedidos y ventas",
    description: "Órdenes, caja, reembolsos y preparación",
    permissions: ["can_manage_orders", "can_operate_pos", "can_approve_pos_product_edit", "can_refund_order", "can_print_kitchen"],
  },
  {
    id: "clientes",
    label: "Clientes",
    description: "Datos sensibles de clientes",
    permissions: ["can_view_customer_phone"],
  },
  {
    id: "sucursales",
    label: "Sucursales",
    description: "Ubicaciones y mesas",
    permissions: ["can_manage_branch", "can_manage_tables"],
  },
  {
    id: "agenda",
    label: "Agenda",
    description: "Turnos, reservas y horarios",
    permissions: ["can_confirm_booking", "can_manage_schedule"],
  },
  {
    id: "marketing",
    label: "Marketing",
    description: "Campañas y mensajes",
    permissions: ["can_send_campaigns"],
  },
  {
    id: "reportes",
    label: "Reportes",
    description: "Métricas e informes",
    permissions: ["can_view_metrics"],
  },
  {
    id: "configuracion",
    label: "Configuración",
    description: "Equipo, marca, integraciones y facturación",
    permissions: [
      "can_manage_team",
      "can_manage_branding",
      "can_manage_integrations",
      "can_manage_billing",
    ],
  },
];
